import { computed, makeObservable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import {
    MarketingMfe,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
} from '@servicetitan/marketing-global-route';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { Routes } from '../../common/enums/routes';
import { AppStore } from '../../common/stores/app.store';

@injectable()
export class RetentionSegmentsStore {
    basename = this.routeStore.getPathnameWithStandaloneRoot(
        MarketingSection.Apps,
        MfeBasenames[MarketingMfe.RetentionSegments],
    );
    @computed get source() {
        return `https://unpkg.servicetitan.com/@servicetitan/marketing-segmentation@${this.standaloneRootStore.appSettings.environmentTag}`;
    }

    @computed get data() {
        return {
            ...this.appStore.defaultMFEData,
            mfeBaseUrl: '',
            campaignManagerRoute: Routes.CampaignManager,
            tenantParentId: this.standaloneRootStore.tenant.parentId ?? '',
        };
    }

    constructor(
        @inject(AppStore) private readonly appStore: AppStore,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
        @inject(MarketingRouteStore) private readonly routeStore: MarketingRouteStore,
    ) {
        makeObservable(this);
    }
}
